// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__3Rrdi"};